import RequestClient from '@shared/services/main/request-client';
import UrlModifier from '@shared/lib/helpers/url-modifier';

/**
 * This prototype describes an List events trait. Encapsulate business logics
 *
 * @class      ListCallable (name)
 */
function ListCallable(component) {
  this.component = component;
}

/**
 * Registers lists events, this follows naming convention
 *
 * @param      {Object}       self         The caller instance
 * @param      {BaseService}  service      The service
 * @param      {string}       module_name  The module name
 */
ListCallable.prototype.registerListEvents = function(self, service) {
  var event_callback_map = {};
  event_callback_map[this.event_group.LIST_PROCEED] = 'onListProceed';
  event_callback_map[this.event_group.LIST_SUCCESS] = 'onListSuccess';
  event_callback_map[this.event_group.LIST_FAIL]    = 'onListFail';
  this.registerEvents(event_callback_map, service);
  return this;
}

/**
 * Removes list events.
 *
 * @param      {<type>}  self         The object
 * @param      {<type>}  service      The service
 * @param      {string}  module_name  The module name
 */
ListCallable.prototype.removeListEvents = function() {
  this.removeEvents([
    this.event_group.LIST_PROCEED,
    this.event_group.LIST_SUCCESS,
    this.event_group.LIST_FAIL
  ]);
  return this;
}

/**
 * Gives the request extra options,
 *
 * NOTE: this will override the same option keys
 *
 * @return     {Object}  The request extra options
 */
ListCallable.prototype.extraListOptions = function() {
  return {};
}

/**
 * Called on events list load.
 *
 * @param      {Object}  options  The options
 */
ListCallable.prototype.onListProceed = function({url, params={}}) {
  /**
   * This is not good, we should probably let params modify the url quries ,
   * but for now let's stick to the plan that we can only use params as query
   * when url is not providd
   */
  if (!Object.keys(params).length) {
    params = this.getComponent().getListParams();
  }

  let _url            = url || this.list_endpoint;
  let existing_params = UrlModifier.paramsToObject(_url);
  let token_source    = this.renewCancelToken(RequestClient, this.event_group.LIST_PROCEED);
  params = Object.assign(params, existing_params);

  this.getComponent().setState({loader: true});
  const options = this.extraListOptions();
  let request = RequestClient.get(this.list_endpoint, {
    cancelToken: token_source.token,
    params: params,
    ...options
  });
  this.bindResultEvents(
    request,
    this.event_group.LIST_SUCCESS,
    this.event_group.LIST_FAIL
  );
  return this;
}

/**
 * Called on events list load.
 *
 * @param      {Object}  response  The response
 */
ListCallable.prototype.onListSuccess = function(response) {
  this.getComponent().setState({pagination: response.data.meta});
  this.getComponent().setState({items: response.data.items});

  if (this.getComponent().hasPagination()) {
    var pagination_param = {...this.getComponent().state.pagination_param}
    pagination_param.page = response.data.meta.current_page;
    pagination_param.per_page = response.data.meta.per_page;
    this.getComponent().setState({pagination_param});
  }
}

/**
 * Called on events list load.
 *
 * @param      {Object}  error   The error
 */
ListCallable.prototype.onListFail = function(error) {
  console.log("ListCallable::onListFail" , error);
}


export default ListCallable;
